import { Domestika } from "@web/domestika";

export const contextFactory = async ({ language }) => {
  const domain = await Domestika.create({
    API_PERFORMANCE_METRICS: [],
    LANGUAGE: language,
    API_URL: window.ENV.API_URL,
    API_LEGACY_URL: window.ENV.API_LEGACY_URL,
    API_AUTH_URL: window.ENV.API_AUTH_URL,
    APP_URL: window.ENV.APP_URL,
  });

  if (typeof window !== "undefined") {
    /* eslint-disable-next-line no-underscore-dangle */
    window.__domain__ = domain;
  }

  return { domain };
};
